<app-sidebar>
  <div class="page">
    <div class="page-header">
      <button mat-button type="button" (click)="backToList()">
        <mat-icon>arrow_back</mat-icon>
        Back
      </button>
      <h1>New Digital Onboarding</h1>
    </div>

    <div class="steps">
      <span [class.active]="step === 1">1. Details</span>
      <span [class.active]="step === 2">2. Confirm match</span>
      <span [class.active]="step === 3">3. SMS confirmation</span>
    </div>

    <form class="wizard-form" [formGroup]="form" *ngIf="step === 1" (ngSubmit)="runMatch()">
      <mat-form-field appearance="outline" class="full">
        <mat-label>ID number</mat-label>
        <input matInput formControlName="idNumber" maxlength="13" autocomplete="off" />
        <mat-error *ngIf="form.get('idNumber')?.hasError('required')">Required</mat-error>
        <mat-error *ngIf="form.get('idNumber')?.hasError('pattern')">Must be 13 digits</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full">
        <mat-label>Cell number</mat-label>
        <input matInput formControlName="cellNumber" maxlength="10" placeholder="0821234567" autocomplete="off" />
        <mat-error *ngIf="form.get('cellNumber')?.hasError('required')">Required</mat-error>
        <mat-error *ngIf="form.get('cellNumber')?.hasError('pattern')">Use format 0821234567</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full">
        <mat-label>Your reference (optional)</mat-label>
        <input matInput formControlName="yourReference" />
      </mat-form-field>

      <button mat-raised-button color="primary" type="submit" [disabled]="matching">
        <mat-spinner *ngIf="matching" diameter="18" class="btn-spinner"></mat-spinner>
        {{ matching ? 'Matching…' : 'Verify Details' }}
      </button>
    </form>

    <div class="preview" *ngIf="step === 2 && preview">
      <p>Confirm this is the correct consumer before sending the verification SMS:</p>
      <dl>
        <dt>Name</dt>
        <dd>{{ preview.titleDesc }} {{ preview.firstName }} {{ preview.surname }}</dd>
        <dt>ID</dt>
        <dd><span class="masked-id">{{ formatId(preview.idNo) }}</span></dd>
        <dt>Birth date</dt>
        <dd>{{ preview.birthDate || '—' }}</dd>
        <dt>Gender</dt>
        <dd>{{ preview.gender || '—' }}</dd>
        <dt>Address</dt>
        <dd>{{ preview.residentialAddress || '—' }}</dd>
      </dl>
      <div class="actions">
        <button mat-stroked-button type="button" (click)="cancelMatch()" [disabled]="starting">Cancel</button>
        <button mat-raised-button color="primary" type="button" (click)="confirmStart()" [disabled]="starting">
          <mat-spinner *ngIf="starting" diameter="18" class="btn-spinner"></mat-spinner>
          {{ starting ? 'Sending…' : 'Send verification SMS' }}
        </button>
      </div>
    </div>

    <div class="success" *ngIf="step === 3">
      <mat-icon color="primary">sms</mat-icon>
      <h2>Verification SMS sent</h2>
      <p>{{ successMessage }}</p>
      <p>The request will appear as pending until the customer completes facial verification.</p>
      <button mat-raised-button color="primary" type="button" (click)="backToList()">View history</button>
    </div>
  </div>
</app-sidebar>
